define('all/special-urls-popup',['module', 'all/slidingContentWrapper', 'all/player/session', 'all/dialog', 'all/player/login', 'legacy/data-TEMP', 'legacy/pw'], function (module, slidingContentWrapper, session, dialog, login) {
    'use strict';
    var configuration = module.config(),
        popup = configuration.popup,
        popupHandlers = {
            register: function () {
                slidingContentWrapper.showSlidingSignup();
            },
            deposit: function () {
                slidingContentWrapper.showSlidingDeposit();
            },
            withdraw: function () {
                slidingContentWrapper.showSlidingWithdraw();
            },
            forgotpw: function () {
                window.forgotPw1();
            },
            verifyemail: function () {
                window.getModalPanelHtml('EmailVerification', configuration.verifyEmailText);
            }
        };

    if (typeof(popupHandlers[popup]) !== 'undefined') {
        popupHandlers[popup]();
    }
});

